var exports = {
  "a": "Box__46Ix1v",
};

module.exports = exports;
